import { render, staticRenderFns } from "./Kantonskirchenrat.vue?vue&type=template&id=65746c6a&scoped=true&"
import script from "./Kantonskirchenrat.vue?vue&type=script&lang=js&"
export * from "./Kantonskirchenrat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65746c6a",
  null
  
)

export default component.exports